define('plugin/additional-fields/view/AdditionalFieldItemView',['require','lib/view/LayoutView','view/helper/DatePicker','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var DatePicker = require('view/helper/DatePicker');
    var Config = require('Config');

    /**
     * Additional field item view
     *
     * @class AdditionalFieldItemView
     */
    return LayoutView.extend({

        modelEvents: {
            'invalid': 'render',
            'change': 'render'
        },

        ui: {
            'input': ':input',
            'select': 'select',
            'daySelect': '.day_select',
            'monthSelect': '.month_select',
            'yearSelect': '.year_select',
            'dateSelect': '.date_select',
            'calendarToggle': '.calendar_toggle',
            'calendarToggleInput': '.calendar_toggle_input',
            'file': 'input:file',
            'fileDelete': '.sb-filedelete'
        },

        events: {
            'change @ui.dateSelect': 'onDateSelectChange',
            'change @ui.input': 'setValue',
            'click @ui.calendarToggle': 'onCalendarButtonClick',
            'click @ui.fileDelete': 'onFileDeleteClick'
        },
        _bookingModel: null,
        _datePicker: null,
        //_monthsList: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        _monthsList: [
            Locale.get('_January_'), Locale.get('_February_'), Locale.get('_March_'), Locale.get('_April_'),
            Locale.get('_May_'), Locale.get('_June_'), Locale.get('_July_'), Locale.get('_August_'),
            Locale.get('_September_'), Locale.get('_October_'), Locale.get('_November_'), Locale.get('_December_')
        ],
        _yearsList: null,
        _daysList: null,

        initialize: function () {
            this._bookingModel = this.getOption('bookingModel');
            this.generateDateFieldsOptions();
        },

        getTemplate: function () {
            var type = this.model.get('type');
            if (type === 'barcode') {
                type = 'text';
            }

            return '#additional_field_' + type;
        },

        onCalendarButtonClick: function() {
            this._datePicker.datepicker('show');
        },

        onCalendarValueChange: function() {
            var date = Date.parseMysqlDate(this.ui.calendarToggleInput.val());

            this.ui.daySelect.val(date.getDate());
            this.ui.monthSelect.val(date.getMonth()+1);
            this.ui.yearSelect.val(date.getFullYear());
            
            this.setValue();
        },

        onDateSelectChange: function() {
            //var dateParts = [~~this.ui.yearSelect.val(), ('0' + ~~this.ui.monthSelect.val()).slice(-2), ('0' + ~~this.ui.daySelect.val()).slice(-2)].join('-');
            //var dateParts = [~~this.ui.yearSelect.val(), ~~this.ui.monthSelect.val(), ~~this.ui.daySelect.val()].join('-');

            var year = this.ui.yearSelect.val();
            if( !year ){
                year = new Date().getFullYear();
            }

            var date = new Date(year, this.ui.monthSelect.val() - 1, this.ui.daySelect.val());
            var dateParts = date.getMysqlDate();

            this._datePicker.datepicker('update', date);
            this.ui.calendarToggleInput.val(dateParts);
            
            /*if (this.ui.yearSelect.val() && this.ui.monthSelect.val() && this.ui.daySelect.val()) {
                var date = new Date(this.ui.yearSelect.val(), this._monthsList.indexOf(this.ui.monthSelect.val()), this.ui.daySelect.val());
                var correctedArray = date.getMysqlDate().split('-');
                this.ui.yearSelect.val(correctedArray[0]);
                this.ui.monthSelect.val(this._monthsList[+correctedArray[1] - 1]);
                this.ui.daySelect.val(+correctedArray[2]);
                this.ui.calendarToggleInput.val(date.getMysqlDate());
            }*/
            
            this.setValue();
        },
        
        onFileDeleteClick: function () {
            var model = this.model;
            
            if (model.get('type') === 'cloud') {
                var hashInput = jQuery('.sb-filehash', this.el);
                var filenameInput = jQuery('.sb-filename', this.el);
                var fileInput = this.ui.file;
                var spiner = jQuery('.file-upload__spinner', this.el);
                
                hashInput.val(null);
                filenameInput.text('');
                fileInput.val('');

                spiner.closest('.file-upload__wrapper').removeClass('selected');

                model.set({
                    value: null,
                    filehash: null
                }, {
                    silent: true
                });

                this.triggerMethod('change');
            }
        },

        generateDateFieldsOptions: function() {
            var maxDay = 31;
            var minYear = new Date().getFullYear() - 120;
            var maxYear = new Date().getFullYear() + 20;

            this._daysList = [];
            this._yearsList = [];

            for (var i = 1; i <= maxDay; i++) {
                this._daysList.push(i);
            }

            for (var j = maxYear; j >= minYear; j--) {
                this._yearsList.push(j);
            }
        },

        onRender: function () {
            if (this.model.get('type') === 'date') {
                if (this.ui.calendarToggle.length > 0) {
                    this._datePicker = DatePicker.initDatepicker(this.ui.calendarToggleInput);
                    this._datePicker.datepicker().on('changeDate changeMonth changeYear', this.onCalendarValueChange.bind(this));
                } else {
                    DatePicker.initDatepicker(this.ui.input);
                }
            }
        },

        setValue: function () {
            var _this = this;
            var model = this.model;
            
            if (model.get('type') === 'cloud') {
                var file = this.ui.file[0].files[0];
                if (file) {
                    var hashInput = jQuery('.sb-filehash', this.el);
                    var filenameInput = jQuery('.sb-filename', this.el);
                    var fileInput = this.ui.file;
                    var spiner = jQuery('.file-upload__spinner', this.el);
                    
                    if (parseInt(file.size) > Config.getMaxCloudFileSize()) {
                        alert(Locale.get('File size is too large')); 
                        fileInput.val('');
                        return;
                    }
                    
                    spiner.addClass('in');

                    var parentId = this.getParentId(); 
                    model.uploadFile(file, parentId).then(function (hash) {
                        spiner.closest('.file-upload__wrapper').addClass('selected');
                        spiner.removeClass('in');

                        hashInput.val(hash);
                        filenameInput.text(file.name);
                        fileInput.val('');

                        model.set({
                            value: file.name,
                            filehash: hash
                        }, {
                            silent: true
                        });

                        _this.triggerMethod('change');
                    }, function (error) {
                        var errorText;
                        if (_.isArray(error)) {
                            errorText = error.map(function (error) { return Locale.get(error); }).join(' ');
                        } else {
                            errorText = error.statusText || error;
                        }
                        spiner.removeClass('in');
                        spiner.closest('.file-upload__wrapper').removeClass('selected');
                        
                        fileInput.val('');
                        alert(errorText);
                    });
                }
                return;
            }
            
            var val = this.ui.input.val();
            if (this.model.get('type') === 'checkbox') {
                val = this.ui.input.is(':checked');
            }
            

            if (this.model.get('type') === 'date') {
                if (this.ui.calendarToggle.length > 0) {
                    val = this.ui.calendarToggleInput.val();
                }
            }

            this.model.set('value', val, {
                silent: true
            });

            this.$el.attr('data-value', '' + val);

            this.triggerMethod('change');
        },
        
        getParentId: function () {
            return this.getOption('bookingModel').id;
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            var format = Config.getInstance().getOption('date_format');
            var dateFormat = format.toLowerCase();

            if (this._bookingModel && this._bookingModel.validationError && this.model.get('name') in this._bookingModel.validationError) {
                data.error = this._bookingModel.validationError[this.model.get('name')];
            }

            if (data.type === 'date' && data.value) {
                var date = Date.parseMysqlDate(data.value);

                data.year_value = date.getFullYear();
                data.month_value = date.getMonth()+1;
                data.day_value = date.getDate();
            }

            if (_.isString(data.values)) {
                var values = data.values.split(',');
                data.values_data = [];
                _.each(values, function (value) {
                    data.values_data.push({
                        value: value,
                        selected: (value === data.value)
                    });
                });
            } else if (_.isArray(data.values)) {
                data.values_data = [];
                _.each(data.values, function (value) {
                    data.values_data.push({
                        value: value.value,
                        selected: (value.value === data.value)
                    });
                });
            }

            data.years = this._yearsList;
            data.months = this._monthsList;
            data.monthsWithIndex = _.object([1,2,3,4,5,6,7,8,9,10,11,12], this._monthsList);
            data.days = this._daysList;

            data.date_order = ['d', 'm', 'y'].sort(function (a, b) { return dateFormat.indexOf(a) - dateFormat.indexOf(b); });
            data.cloud_file_max_size_mb = Config.getInstance().getOption('max_cloud_upload_mb') || 5;
            data.cloud_file_supported_formats = Config.getInstance().getOption('cloud_file_supported_formats') || '';
            return data;
        }

    });

});
